(function (factory) {
    "use strict";
    typeof define == "function" && define.amd
        ? define(["jquery"], factory)
        : typeof exports != "undefined"
          ? (module.exports = factory(require("jquery")))
          : factory(jQuery);
})(function ($) {
    "use strict";
    var Slick = window.Slick || {};
    (Slick = (function () {
        var instanceUid = 0;
        function Slick2(element, settings) {
            var _ = this,
                dataSettings;
            (_.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: 0.35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3,
            }),
                (_.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    scrolling: !1,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    swiping: !1,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1,
                }),
                $.extend(_, _.initials),
                (_.activeBreakpoint = null),
                (_.animType = null),
                (_.animProp = null),
                (_.breakpoints = []),
                (_.breakpointSettings = []),
                (_.cssTransitions = !1),
                (_.focussed = !1),
                (_.interrupted = !1),
                (_.hidden = "hidden"),
                (_.paused = !0),
                (_.positionProp = null),
                (_.respondTo = null),
                (_.rowCount = 1),
                (_.shouldClick = !0),
                (_.$slider = $(element)),
                (_.$slidesCache = null),
                (_.transformType = null),
                (_.transitionType = null),
                (_.visibilityChange = "visibilitychange"),
                (_.windowWidth = 0),
                (_.windowTimer = null),
                (dataSettings = $(element).data("slick") || {}),
                (_.options = $.extend({}, _.defaults, settings, dataSettings)),
                (_.currentSlide = _.options.initialSlide),
                (_.originalSettings = _.options),
                typeof document.mozHidden != "undefined"
                    ? ((_.hidden = "mozHidden"), (_.visibilityChange = "mozvisibilitychange"))
                    : typeof document.webkitHidden != "undefined" &&
                      ((_.hidden = "webkitHidden"), (_.visibilityChange = "webkitvisibilitychange")),
                (_.autoPlay = $.proxy(_.autoPlay, _)),
                (_.autoPlayClear = $.proxy(_.autoPlayClear, _)),
                (_.autoPlayIterator = $.proxy(_.autoPlayIterator, _)),
                (_.changeSlide = $.proxy(_.changeSlide, _)),
                (_.clickHandler = $.proxy(_.clickHandler, _)),
                (_.selectHandler = $.proxy(_.selectHandler, _)),
                (_.setPosition = $.proxy(_.setPosition, _)),
                (_.swipeHandler = $.proxy(_.swipeHandler, _)),
                (_.dragHandler = $.proxy(_.dragHandler, _)),
                (_.keyHandler = $.proxy(_.keyHandler, _)),
                (_.instanceUid = instanceUid++),
                (_.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                _.registerBreakpoints(),
                _.init(!0);
        }
        return Slick2;
    })()),
        (Slick.prototype.activateADA = function () {
            var _ = this;
            _.$slideTrack
                .find(".slick-active")
                .attr({ "aria-hidden": "false" })
                .find("a, input, button, select")
                .attr({ tabindex: "0" });
        }),
        (Slick.prototype.addSlide = Slick.prototype.slickAdd =
            function (markup, index, addBefore) {
                var _ = this;
                if (typeof index == "boolean") (addBefore = index), (index = null);
                else if (index < 0 || index >= _.slideCount) return !1;
                _.unload(),
                    typeof index == "number"
                        ? index === 0 && _.$slides.length === 0
                            ? $(markup).appendTo(_.$slideTrack)
                            : addBefore
                              ? $(markup).insertBefore(_.$slides.eq(index))
                              : $(markup).insertAfter(_.$slides.eq(index))
                        : addBefore === !0
                          ? $(markup).prependTo(_.$slideTrack)
                          : $(markup).appendTo(_.$slideTrack),
                    (_.$slides = _.$slideTrack.children(this.options.slide)),
                    _.$slideTrack.children(this.options.slide).detach(),
                    _.$slideTrack.append(_.$slides),
                    _.$slides.each(function (index2, element) {
                        $(element).attr("data-slick-index", index2);
                    }),
                    (_.$slidesCache = _.$slides),
                    _.reinit();
            }),
        (Slick.prototype.animateHeight = function () {
            var _ = this;
            if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === !0 && _.options.vertical === !1) {
                var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(!0);
                _.$list.animate({ height: targetHeight }, _.options.speed);
            }
        }),
        (Slick.prototype.animateSlide = function (targetLeft, callback) {
            var animProps = {},
                _ = this;
            _.animateHeight(),
                _.options.rtl === !0 && _.options.vertical === !1 && (targetLeft = -targetLeft),
                _.transformsEnabled === !1
                    ? _.options.vertical === !1
                        ? _.$slideTrack.animate({ left: targetLeft }, _.options.speed, _.options.easing, callback)
                        : _.$slideTrack.animate({ top: targetLeft }, _.options.speed, _.options.easing, callback)
                    : _.cssTransitions === !1
                      ? (_.options.rtl === !0 && (_.currentLeft = -_.currentLeft),
                        $({ animStart: _.currentLeft }).animate(
                            { animStart: targetLeft },
                            {
                                duration: _.options.speed,
                                easing: _.options.easing,
                                step: function (now) {
                                    (now = Math.ceil(now)),
                                        _.options.vertical === !1
                                            ? ((animProps[_.animType] = "translate(" + now + "px, 0px)"),
                                              _.$slideTrack.css(animProps))
                                            : ((animProps[_.animType] = "translate(0px," + now + "px)"),
                                              _.$slideTrack.css(animProps));
                                },
                                complete: function () {
                                    callback && callback.call();
                                },
                            }
                        ))
                      : (_.applyTransition(),
                        (targetLeft = Math.ceil(targetLeft)),
                        _.options.vertical === !1
                            ? (animProps[_.animType] = "translate3d(" + targetLeft + "px, 0px, 0px)")
                            : (animProps[_.animType] = "translate3d(0px," + targetLeft + "px, 0px)"),
                        _.$slideTrack.css(animProps),
                        callback &&
                            setTimeout(function () {
                                _.disableTransition(), callback.call();
                            }, _.options.speed));
        }),
        (Slick.prototype.getNavTarget = function () {
            var _ = this,
                asNavFor = _.options.asNavFor;
            return asNavFor && asNavFor !== null && (asNavFor = $(asNavFor).not(_.$slider)), asNavFor;
        }),
        (Slick.prototype.asNavFor = function (index) {
            var _ = this,
                asNavFor = _.getNavTarget();
            asNavFor !== null &&
                typeof asNavFor == "object" &&
                asNavFor.each(function () {
                    var target = $(this).slick("getSlick");
                    target.unslicked || target.slideHandler(index, !0);
                });
        }),
        (Slick.prototype.applyTransition = function (slide) {
            var _ = this,
                transition = {};
            _.options.fade === !1
                ? (transition[_.transitionType] = _.transformType + " " + _.options.speed + "ms " + _.options.cssEase)
                : (transition[_.transitionType] = "opacity " + _.options.speed + "ms " + _.options.cssEase),
                _.options.fade === !1 ? _.$slideTrack.css(transition) : _.$slides.eq(slide).css(transition);
        }),
        (Slick.prototype.autoPlay = function () {
            var _ = this;
            _.autoPlayClear(),
                _.slideCount > _.options.slidesToShow &&
                    (_.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed));
        }),
        (Slick.prototype.autoPlayClear = function () {
            var _ = this;
            _.autoPlayTimer && clearInterval(_.autoPlayTimer);
        }),
        (Slick.prototype.autoPlayIterator = function () {
            var _ = this,
                slideTo = _.currentSlide + _.options.slidesToScroll;
            !_.paused &&
                !_.interrupted &&
                !_.focussed &&
                (_.options.infinite === !1 &&
                    (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1
                        ? (_.direction = 0)
                        : _.direction === 0 &&
                          ((slideTo = _.currentSlide - _.options.slidesToScroll),
                          _.currentSlide - 1 === 0 && (_.direction = 1))),
                _.slideHandler(slideTo));
        }),
        (Slick.prototype.buildArrows = function () {
            var _ = this;
            _.options.arrows === !0 &&
                ((_.$prevArrow = $(_.options.prevArrow).addClass("slick-arrow")),
                (_.$nextArrow = $(_.options.nextArrow).addClass("slick-arrow")),
                _.slideCount > _.options.slidesToShow
                    ? (_.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                      _.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                      _.htmlExpr.test(_.options.prevArrow) && _.$prevArrow.prependTo(_.options.appendArrows),
                      _.htmlExpr.test(_.options.nextArrow) && _.$nextArrow.appendTo(_.options.appendArrows),
                      _.options.infinite !== !0 &&
                          _.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                    : _.$prevArrow
                          .add(_.$nextArrow)
                          .addClass("slick-hidden")
                          .attr({ "aria-disabled": "true", tabindex: "-1" }));
        }),
        (Slick.prototype.buildDots = function () {
            var _ = this,
                i,
                dot;
            if (_.options.dots === !0 && _.slideCount > _.options.slidesToShow) {
                for (
                    _.$slider.addClass("slick-dotted"), dot = $("<ul />").addClass(_.options.dotsClass), i = 0;
                    i <= _.getDotCount();
                    i += 1
                )
                    dot.append($("<li />").append(_.options.customPaging.call(this, _, i)));
                (_.$dots = dot.appendTo(_.options.appendDots)), _.$dots.find("li").first().addClass("slick-active");
            }
        }),
        (Slick.prototype.buildOut = function () {
            var _ = this;
            (_.$slides = _.$slider.children(_.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                (_.slideCount = _.$slides.length),
                _.$slides.each(function (index, element) {
                    $(element)
                        .attr("data-slick-index", index)
                        .data("originalStyling", $(element).attr("style") || "");
                }),
                _.$slider.addClass("slick-slider"),
                (_.$slideTrack =
                    _.slideCount === 0
                        ? $('<div class="slick-track"/>').appendTo(_.$slider)
                        : _.$slides.wrapAll('<div class="slick-track"/>').parent()),
                (_.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                _.$slideTrack.css("opacity", 0),
                (_.options.centerMode === !0 || _.options.swipeToSlide === !0) && (_.options.slidesToScroll = 1),
                $("img[data-lazy]", _.$slider).not("[src]").addClass("slick-loading"),
                _.setupInfinite(),
                _.buildArrows(),
                _.buildDots(),
                _.updateDots(),
                _.setSlideClasses(typeof _.currentSlide == "number" ? _.currentSlide : 0),
                _.options.draggable === !0 && _.$list.addClass("draggable");
        }),
        (Slick.prototype.buildRows = function () {
            var _ = this,
                a,
                b,
                c,
                newSlides,
                numOfSlides,
                originalSlides,
                slidesPerSection;
            if (
                ((newSlides = document.createDocumentFragment()),
                (originalSlides = _.$slider.children()),
                _.options.rows > 0)
            ) {
                for (
                    slidesPerSection = _.options.slidesPerRow * _.options.rows,
                        numOfSlides = Math.ceil(originalSlides.length / slidesPerSection),
                        a = 0;
                    a < numOfSlides;
                    a++
                ) {
                    var slide = document.createElement("div");
                    for (b = 0; b < _.options.rows; b++) {
                        var row = document.createElement("div");
                        for (c = 0; c < _.options.slidesPerRow; c++) {
                            var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                            originalSlides.get(target) && row.appendChild(originalSlides.get(target));
                        }
                        slide.appendChild(row);
                    }
                    newSlides.appendChild(slide);
                }
                _.$slider.empty().append(newSlides),
                    _.$slider
                        .children()
                        .children()
                        .children()
                        .css({ width: 100 / _.options.slidesPerRow + "%", display: "inline-block" });
            }
        }),
        (Slick.prototype.checkResponsive = function (initial, forceUpdate) {
            var _ = this,
                breakpoint,
                targetBreakpoint,
                respondToWidth,
                triggerBreakpoint = !1,
                sliderWidth = _.$slider.width(),
                windowWidth = window.innerWidth || $(window).width();
            if (
                (_.respondTo === "window"
                    ? (respondToWidth = windowWidth)
                    : _.respondTo === "slider"
                      ? (respondToWidth = sliderWidth)
                      : _.respondTo === "min" && (respondToWidth = Math.min(windowWidth, sliderWidth)),
                _.options.responsive && _.options.responsive.length && _.options.responsive !== null)
            ) {
                targetBreakpoint = null;
                for (breakpoint in _.breakpoints)
                    _.breakpoints.hasOwnProperty(breakpoint) &&
                        (_.originalSettings.mobileFirst === !1
                            ? respondToWidth < _.breakpoints[breakpoint] &&
                              (targetBreakpoint = _.breakpoints[breakpoint])
                            : respondToWidth > _.breakpoints[breakpoint] &&
                              (targetBreakpoint = _.breakpoints[breakpoint]));
                targetBreakpoint !== null
                    ? _.activeBreakpoint !== null
                        ? (targetBreakpoint !== _.activeBreakpoint || forceUpdate) &&
                          ((_.activeBreakpoint = targetBreakpoint),
                          _.breakpointSettings[targetBreakpoint] === "unslick"
                              ? _.unslick(targetBreakpoint)
                              : ((_.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint])),
                                initial === !0 && (_.currentSlide = _.options.initialSlide),
                                _.refresh(initial)),
                          (triggerBreakpoint = targetBreakpoint))
                        : ((_.activeBreakpoint = targetBreakpoint),
                          _.breakpointSettings[targetBreakpoint] === "unslick"
                              ? _.unslick(targetBreakpoint)
                              : ((_.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint])),
                                initial === !0 && (_.currentSlide = _.options.initialSlide),
                                _.refresh(initial)),
                          (triggerBreakpoint = targetBreakpoint))
                    : _.activeBreakpoint !== null &&
                      ((_.activeBreakpoint = null),
                      (_.options = _.originalSettings),
                      initial === !0 && (_.currentSlide = _.options.initialSlide),
                      _.refresh(initial),
                      (triggerBreakpoint = targetBreakpoint)),
                    !initial && triggerBreakpoint !== !1 && _.$slider.trigger("breakpoint", [_, triggerBreakpoint]);
            }
        }),
        (Slick.prototype.changeSlide = function (event, dontAnimate) {
            var _ = this,
                $target = $(event.currentTarget),
                indexOffset,
                slideOffset,
                unevenOffset;
            switch (
                ($target.is("a") && event.preventDefault(),
                $target.is("li") || ($target = $target.closest("li")),
                (unevenOffset = _.slideCount % _.options.slidesToScroll !== 0),
                (indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll),
                event.data.message)
            ) {
                case "previous":
                    (slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset),
                        _.slideCount > _.options.slidesToShow &&
                            _.slideHandler(_.currentSlide - slideOffset, !1, dontAnimate);
                    break;
                case "next":
                    (slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset),
                        _.slideCount > _.options.slidesToShow &&
                            _.slideHandler(_.currentSlide + slideOffset, !1, dontAnimate);
                    break;
                case "index":
                    var index =
                        event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                    _.slideHandler(_.checkNavigable(index), !1, dontAnimate), $target.children().trigger("focus");
                    break;
                default:
                    return;
            }
        }),
        (Slick.prototype.checkNavigable = function (index) {
            var _ = this,
                navigables,
                prevNavigable;
            if (
                ((navigables = _.getNavigableIndexes()), (prevNavigable = 0), index > navigables[navigables.length - 1])
            )
                index = navigables[navigables.length - 1];
            else
                for (var n in navigables) {
                    if (index < navigables[n]) {
                        index = prevNavigable;
                        break;
                    }
                    prevNavigable = navigables[n];
                }
            return index;
        }),
        (Slick.prototype.cleanUpEvents = function () {
            var _ = this;
            _.options.dots &&
                _.$dots !== null &&
                ($("li", _.$dots)
                    .off("click.slick", _.changeSlide)
                    .off("mouseenter.slick", $.proxy(_.interrupt, _, !0))
                    .off("mouseleave.slick", $.proxy(_.interrupt, _, !1)),
                _.options.accessibility === !0 && _.$dots.off("keydown.slick", _.keyHandler)),
                _.$slider.off("focus.slick blur.slick"),
                _.options.arrows === !0 &&
                    _.slideCount > _.options.slidesToShow &&
                    (_.$prevArrow && _.$prevArrow.off("click.slick", _.changeSlide),
                    _.$nextArrow && _.$nextArrow.off("click.slick", _.changeSlide),
                    _.options.accessibility === !0 &&
                        (_.$prevArrow && _.$prevArrow.off("keydown.slick", _.keyHandler),
                        _.$nextArrow && _.$nextArrow.off("keydown.slick", _.keyHandler))),
                _.$list.off("touchstart.slick mousedown.slick", _.swipeHandler),
                _.$list.off("touchmove.slick mousemove.slick", _.swipeHandler),
                _.$list.off("touchend.slick mouseup.slick", _.swipeHandler),
                _.$list.off("touchcancel.slick mouseleave.slick", _.swipeHandler),
                _.$list.off("click.slick", _.clickHandler),
                $(document).off(_.visibilityChange, _.visibility),
                _.cleanUpSlideEvents(),
                _.options.accessibility === !0 && _.$list.off("keydown.slick", _.keyHandler),
                _.options.focusOnSelect === !0 && $(_.$slideTrack).children().off("click.slick", _.selectHandler),
                $(window).off("orientationchange.slick.slick-" + _.instanceUid, _.orientationChange),
                $(window).off("resize.slick.slick-" + _.instanceUid, _.resize),
                $("[draggable!=true]", _.$slideTrack).off("dragstart", _.preventDefault),
                $(window).off("load.slick.slick-" + _.instanceUid, _.setPosition);
        }),
        (Slick.prototype.cleanUpSlideEvents = function () {
            var _ = this;
            _.$list.off("mouseenter.slick", $.proxy(_.interrupt, _, !0)),
                _.$list.off("mouseleave.slick", $.proxy(_.interrupt, _, !1));
        }),
        (Slick.prototype.cleanUpRows = function () {
            var _ = this,
                originalSlides;
            _.options.rows > 0 &&
                ((originalSlides = _.$slides.children().children()),
                originalSlides.removeAttr("style"),
                _.$slider.empty().append(originalSlides));
        }),
        (Slick.prototype.clickHandler = function (event) {
            var _ = this;
            _.shouldClick === !1 && (event.stopImmediatePropagation(), event.stopPropagation(), event.preventDefault());
        }),
        (Slick.prototype.destroy = function (refresh) {
            var _ = this;
            _.autoPlayClear(),
                (_.touchObject = {}),
                _.cleanUpEvents(),
                $(".slick-cloned", _.$slider).detach(),
                _.$dots && _.$dots.remove(),
                _.$prevArrow &&
                    _.$prevArrow.length &&
                    (_.$prevArrow
                        .removeClass("slick-disabled slick-arrow slick-hidden")
                        .removeAttr("aria-hidden aria-disabled tabindex")
                        .css("display", ""),
                    _.htmlExpr.test(_.options.prevArrow) && _.$prevArrow.remove()),
                _.$nextArrow &&
                    _.$nextArrow.length &&
                    (_.$nextArrow
                        .removeClass("slick-disabled slick-arrow slick-hidden")
                        .removeAttr("aria-hidden aria-disabled tabindex")
                        .css("display", ""),
                    _.htmlExpr.test(_.options.nextArrow) && _.$nextArrow.remove()),
                _.$slides &&
                    (_.$slides
                        .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                        .removeAttr("aria-hidden")
                        .removeAttr("data-slick-index")
                        .each(function () {
                            $(this).attr("style", $(this).data("originalStyling"));
                        }),
                    _.$slideTrack.children(this.options.slide).detach(),
                    _.$slideTrack.detach(),
                    _.$list.detach(),
                    _.$slider.append(_.$slides)),
                _.cleanUpRows(),
                _.$slider.removeClass("slick-slider"),
                _.$slider.removeClass("slick-initialized"),
                _.$slider.removeClass("slick-dotted"),
                (_.unslicked = !0),
                refresh || _.$slider.trigger("destroy", [_]);
        }),
        (Slick.prototype.disableTransition = function (slide) {
            var _ = this,
                transition = {};
            (transition[_.transitionType] = ""),
                _.options.fade === !1 ? _.$slideTrack.css(transition) : _.$slides.eq(slide).css(transition);
        }),
        (Slick.prototype.fadeSlide = function (slideIndex, callback) {
            var _ = this;
            _.cssTransitions === !1
                ? (_.$slides.eq(slideIndex).css({ zIndex: _.options.zIndex }),
                  _.$slides.eq(slideIndex).animate({ opacity: 1 }, _.options.speed, _.options.easing, callback))
                : (_.applyTransition(slideIndex),
                  _.$slides.eq(slideIndex).css({ opacity: 1, zIndex: _.options.zIndex }),
                  callback &&
                      setTimeout(function () {
                          _.disableTransition(slideIndex), callback.call();
                      }, _.options.speed));
        }),
        (Slick.prototype.fadeSlideOut = function (slideIndex) {
            var _ = this;
            _.cssTransitions === !1
                ? _.$slides
                      .eq(slideIndex)
                      .animate({ opacity: 0, zIndex: _.options.zIndex - 2 }, _.options.speed, _.options.easing)
                : (_.applyTransition(slideIndex),
                  _.$slides.eq(slideIndex).css({ opacity: 0, zIndex: _.options.zIndex - 2 }));
        }),
        (Slick.prototype.filterSlides = Slick.prototype.slickFilter =
            function (filter) {
                var _ = this;
                filter !== null &&
                    ((_.$slidesCache = _.$slides),
                    _.unload(),
                    _.$slideTrack.children(this.options.slide).detach(),
                    _.$slidesCache.filter(filter).appendTo(_.$slideTrack),
                    _.reinit());
            }),
        (Slick.prototype.focusHandler = function () {
            var _ = this;
            _.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (event) {
                event.stopImmediatePropagation();
                var $sf = $(this);
                setTimeout(function () {
                    _.options.pauseOnFocus && ((_.focussed = $sf.is(":focus")), _.autoPlay());
                }, 0);
            });
        }),
        (Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide =
            function () {
                var _ = this;
                return _.currentSlide;
            }),
        (Slick.prototype.getDotCount = function () {
            var _ = this,
                breakPoint = 0,
                counter = 0,
                pagerQty = 0;
            if (_.options.infinite === !0)
                if (_.slideCount <= _.options.slidesToShow) ++pagerQty;
                else
                    for (; breakPoint < _.slideCount; )
                        ++pagerQty,
                            (breakPoint = counter + _.options.slidesToScroll),
                            (counter +=
                                _.options.slidesToScroll <= _.options.slidesToShow
                                    ? _.options.slidesToScroll
                                    : _.options.slidesToShow);
            else if (_.options.centerMode === !0) pagerQty = _.slideCount;
            else if (!_.options.asNavFor)
                pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
            else
                for (; breakPoint < _.slideCount; )
                    ++pagerQty,
                        (breakPoint = counter + _.options.slidesToScroll),
                        (counter +=
                            _.options.slidesToScroll <= _.options.slidesToShow
                                ? _.options.slidesToScroll
                                : _.options.slidesToShow);
            return pagerQty - 1;
        }),
        (Slick.prototype.getLeft = function (slideIndex) {
            var _ = this,
                targetLeft,
                verticalHeight,
                verticalOffset = 0,
                targetSlide,
                coef;
            return (
                (_.slideOffset = 0),
                (verticalHeight = _.$slides.first().outerHeight(!0)),
                _.options.infinite === !0
                    ? (_.slideCount > _.options.slidesToShow &&
                          ((_.slideOffset = _.slideWidth * _.options.slidesToShow * -1),
                          (coef = -1),
                          _.options.vertical === !0 &&
                              _.options.centerMode === !0 &&
                              (_.options.slidesToShow === 2
                                  ? (coef = -1.5)
                                  : _.options.slidesToShow === 1 && (coef = -2)),
                          (verticalOffset = verticalHeight * _.options.slidesToShow * coef)),
                      _.slideCount % _.options.slidesToScroll !== 0 &&
                          slideIndex + _.options.slidesToScroll > _.slideCount &&
                          _.slideCount > _.options.slidesToShow &&
                          (slideIndex > _.slideCount
                              ? ((_.slideOffset =
                                    (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1),
                                (verticalOffset =
                                    (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1))
                              : ((_.slideOffset = (_.slideCount % _.options.slidesToScroll) * _.slideWidth * -1),
                                (verticalOffset = (_.slideCount % _.options.slidesToScroll) * verticalHeight * -1))))
                    : slideIndex + _.options.slidesToShow > _.slideCount &&
                      ((_.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth),
                      (verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight)),
                _.slideCount <= _.options.slidesToShow && ((_.slideOffset = 0), (verticalOffset = 0)),
                _.options.centerMode === !0 && _.slideCount <= _.options.slidesToShow
                    ? (_.slideOffset =
                          (_.slideWidth * Math.floor(_.options.slidesToShow)) / 2 - (_.slideWidth * _.slideCount) / 2)
                    : _.options.centerMode === !0 && _.options.infinite === !0
                      ? (_.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth)
                      : _.options.centerMode === !0 &&
                        ((_.slideOffset = 0), (_.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2))),
                _.options.vertical === !1
                    ? (targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset)
                    : (targetLeft = slideIndex * verticalHeight * -1 + verticalOffset),
                _.options.variableWidth === !0 &&
                    (_.slideCount <= _.options.slidesToShow || _.options.infinite === !1
                        ? (targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex))
                        : (targetSlide = _.$slideTrack
                              .children(".slick-slide")
                              .eq(slideIndex + _.options.slidesToShow)),
                    _.options.rtl === !0
                        ? targetSlide[0]
                            ? (targetLeft =
                                  (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1)
                            : (targetLeft = 0)
                        : (targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0),
                    _.options.centerMode === !0 &&
                        (_.slideCount <= _.options.slidesToShow || _.options.infinite === !1
                            ? (targetSlide = _.$slideTrack.children(".slick-slide").eq(slideIndex))
                            : (targetSlide = _.$slideTrack
                                  .children(".slick-slide")
                                  .eq(slideIndex + _.options.slidesToShow + 1)),
                        _.options.rtl === !0
                            ? targetSlide[0]
                                ? (targetLeft =
                                      (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1)
                                : (targetLeft = 0)
                            : (targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0),
                        (targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2))),
                targetLeft
            );
        }),
        (Slick.prototype.getOption = Slick.prototype.slickGetOption =
            function (option) {
                var _ = this;
                return _.options[option];
            }),
        (Slick.prototype.getNavigableIndexes = function () {
            var _ = this,
                breakPoint = 0,
                counter = 0,
                indexes = [],
                max;
            for (
                _.options.infinite === !1
                    ? (max = _.slideCount)
                    : ((breakPoint = _.options.slidesToScroll * -1),
                      (counter = _.options.slidesToScroll * -1),
                      (max = _.slideCount * 2));
                breakPoint < max;

            )
                indexes.push(breakPoint),
                    (breakPoint = counter + _.options.slidesToScroll),
                    (counter +=
                        _.options.slidesToScroll <= _.options.slidesToShow
                            ? _.options.slidesToScroll
                            : _.options.slidesToShow);
            return indexes;
        }),
        (Slick.prototype.getSlick = function () {
            return this;
        }),
        (Slick.prototype.getSlideCount = function () {
            var _ = this,
                slidesTraversed,
                swipedSlide,
                centerOffset;
            return (
                (centerOffset =
                    _.options.centerMode === !0 ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0),
                _.options.swipeToSlide === !0
                    ? (_.$slideTrack.find(".slick-slide").each(function (index, slide) {
                          if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1)
                              return (swipedSlide = slide), !1;
                      }),
                      (slidesTraversed = Math.abs($(swipedSlide).attr("data-slick-index") - _.currentSlide) || 1),
                      slidesTraversed)
                    : _.options.slidesToScroll
            );
        }),
        (Slick.prototype.goTo = Slick.prototype.slickGoTo =
            function (slide, dontAnimate) {
                var _ = this;
                _.changeSlide({ data: { message: "index", index: parseInt(slide) } }, dontAnimate);
            }),
        (Slick.prototype.init = function (creation) {
            var _ = this;
            $(_.$slider).hasClass("slick-initialized") ||
                ($(_.$slider).addClass("slick-initialized"),
                _.buildRows(),
                _.buildOut(),
                _.setProps(),
                _.startLoad(),
                _.loadSlider(),
                _.initializeEvents(),
                _.updateArrows(),
                _.updateDots(),
                _.checkResponsive(!0),
                _.focusHandler()),
                creation && _.$slider.trigger("init", [_]),
                _.options.accessibility === !0 && _.initADA(),
                _.options.autoplay && ((_.paused = !1), _.autoPlay());
        }),
        (Slick.prototype.initADA = function () {
            var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
                    return val >= 0 && val < _.slideCount;
                });
            _.$slides
                .add(_.$slideTrack.find(".slick-cloned"))
                .attr({ "aria-hidden": "true", tabindex: "-1" })
                .find("a, input, button, select")
                .attr({ tabindex: "-1" }),
                _.$dots !== null &&
                    (_.$slides.not(_.$slideTrack.find(".slick-cloned")).each(function (i2) {
                        var slideControlIndex = tabControlIndexes.indexOf(i2);
                        if (
                            ($(this).attr({ role: "tabpanel", id: "slick-slide" + _.instanceUid + i2, tabindex: -1 }),
                            slideControlIndex !== -1)
                        ) {
                            var ariaButtonControl = "slick-slide-control" + _.instanceUid + slideControlIndex;
                            $("#" + ariaButtonControl).length &&
                                $(this).attr({ "aria-describedby": ariaButtonControl });
                        }
                    }),
                    _.$dots
                        .attr("role", "tablist")
                        .find("li")
                        .each(function (i2) {
                            var mappedSlideIndex = tabControlIndexes[i2];
                            $(this).attr({ role: "presentation" }),
                                $(this)
                                    .find("button")
                                    .first()
                                    .attr({
                                        role: "tab",
                                        id: "slick-slide-control" + _.instanceUid + i2,
                                        "aria-controls": "slick-slide" + _.instanceUid + mappedSlideIndex,
                                        "aria-label": i2 + 1 + " of " + numDotGroups,
                                        "aria-selected": null,
                                        tabindex: "-1",
                                    });
                        })
                        .eq(_.currentSlide)
                        .find("button")
                        .attr({ "aria-selected": "true", tabindex: "0" })
                        .end());
            for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++)
                _.options.focusOnChange
                    ? _.$slides.eq(i).attr({ tabindex: "0" })
                    : _.$slides.eq(i).removeAttr("tabindex");
            _.activateADA();
        }),
        (Slick.prototype.initArrowEvents = function () {
            var _ = this;
            _.options.arrows === !0 &&
                _.slideCount > _.options.slidesToShow &&
                (_.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, _.changeSlide),
                _.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, _.changeSlide),
                _.options.accessibility === !0 &&
                    (_.$prevArrow.on("keydown.slick", _.keyHandler), _.$nextArrow.on("keydown.slick", _.keyHandler)));
        }),
        (Slick.prototype.initDotEvents = function () {
            var _ = this;
            _.options.dots === !0 &&
                _.slideCount > _.options.slidesToShow &&
                ($("li", _.$dots).on("click.slick", { message: "index" }, _.changeSlide),
                _.options.accessibility === !0 && _.$dots.on("keydown.slick", _.keyHandler)),
                _.options.dots === !0 &&
                    _.options.pauseOnDotsHover === !0 &&
                    _.slideCount > _.options.slidesToShow &&
                    $("li", _.$dots)
                        .on("mouseenter.slick", $.proxy(_.interrupt, _, !0))
                        .on("mouseleave.slick", $.proxy(_.interrupt, _, !1));
        }),
        (Slick.prototype.initSlideEvents = function () {
            var _ = this;
            _.options.pauseOnHover &&
                (_.$list.on("mouseenter.slick", $.proxy(_.interrupt, _, !0)),
                _.$list.on("mouseleave.slick", $.proxy(_.interrupt, _, !1)));
        }),
        (Slick.prototype.initializeEvents = function () {
            var _ = this;
            _.initArrowEvents(),
                _.initDotEvents(),
                _.initSlideEvents(),
                _.$list.on("touchstart.slick mousedown.slick", { action: "start" }, _.swipeHandler),
                _.$list.on("touchmove.slick mousemove.slick", { action: "move" }, _.swipeHandler),
                _.$list.on("touchend.slick mouseup.slick", { action: "end" }, _.swipeHandler),
                _.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, _.swipeHandler),
                _.$list.on("click.slick", _.clickHandler),
                $(document).on(_.visibilityChange, $.proxy(_.visibility, _)),
                _.options.accessibility === !0 && _.$list.on("keydown.slick", _.keyHandler),
                _.options.focusOnSelect === !0 && $(_.$slideTrack).children().on("click.slick", _.selectHandler),
                $(window).on("orientationchange.slick.slick-" + _.instanceUid, $.proxy(_.orientationChange, _)),
                $(window).on("resize.slick.slick-" + _.instanceUid, $.proxy(_.resize, _)),
                $("[draggable!=true]", _.$slideTrack).on("dragstart", _.preventDefault),
                $(window).on("load.slick.slick-" + _.instanceUid, _.setPosition),
                $(_.setPosition);
        }),
        (Slick.prototype.initUI = function () {
            var _ = this;
            _.options.arrows === !0 &&
                _.slideCount > _.options.slidesToShow &&
                (_.$prevArrow.show(), _.$nextArrow.show()),
                _.options.dots === !0 && _.slideCount > _.options.slidesToShow && _.$dots.show();
        }),
        (Slick.prototype.keyHandler = function (event) {
            var _ = this;
            event.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                (event.keyCode === 37 && _.options.accessibility === !0
                    ? _.changeSlide({ data: { message: _.options.rtl === !0 ? "next" : "previous" } })
                    : event.keyCode === 39 &&
                      _.options.accessibility === !0 &&
                      _.changeSlide({ data: { message: _.options.rtl === !0 ? "previous" : "next" } }));
        }),
        (Slick.prototype.lazyLoad = function () {
            var _ = this,
                loadRange,
                cloneRange,
                rangeStart,
                rangeEnd;
            function loadImages(imagesScope) {
                $("img[data-lazy]", imagesScope).each(function () {
                    var image = $(this),
                        imageSource = $(this).attr("data-lazy"),
                        imageSrcSet = $(this).attr("data-srcset"),
                        imageSizes = $(this).attr("data-sizes") || _.$slider.attr("data-sizes"),
                        imageToLoad = document.createElement("img");
                    (imageToLoad.onload = function () {
                        image.animate({ opacity: 0 }, 100, function () {
                            imageSrcSet &&
                                (image.attr("srcset", imageSrcSet), imageSizes && image.attr("sizes", imageSizes)),
                                image.attr("src", imageSource).animate({ opacity: 1 }, 200, function () {
                                    image.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                }),
                                _.$slider.trigger("lazyLoaded", [_, image, imageSource]);
                        });
                    }),
                        (imageToLoad.onerror = function () {
                            image.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                                _.$slider.trigger("lazyLoadError", [_, image, imageSource]);
                        }),
                        (imageToLoad.src = imageSource);
                });
            }
            if (
                (_.options.centerMode === !0
                    ? _.options.infinite === !0
                        ? ((rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1)),
                          (rangeEnd = rangeStart + _.options.slidesToShow + 2))
                        : ((rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1))),
                          (rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide))
                    : ((rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide),
                      (rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow)),
                      _.options.fade === !0 &&
                          (rangeStart > 0 && rangeStart--, rangeEnd <= _.slideCount && rangeEnd++)),
                (loadRange = _.$slider.find(".slick-slide").slice(rangeStart, rangeEnd)),
                _.options.lazyLoad === "anticipated")
            )
                for (
                    var prevSlide = rangeStart - 1,
                        nextSlide = rangeEnd,
                        $slides = _.$slider.find(".slick-slide"),
                        i = 0;
                    i < _.options.slidesToScroll;
                    i++
                )
                    prevSlide < 0 && (prevSlide = _.slideCount - 1),
                        (loadRange = loadRange.add($slides.eq(prevSlide))),
                        (loadRange = loadRange.add($slides.eq(nextSlide))),
                        prevSlide--,
                        nextSlide++;
            loadImages(loadRange),
                _.slideCount <= _.options.slidesToShow
                    ? ((cloneRange = _.$slider.find(".slick-slide")), loadImages(cloneRange))
                    : _.currentSlide >= _.slideCount - _.options.slidesToShow
                      ? ((cloneRange = _.$slider.find(".slick-cloned").slice(0, _.options.slidesToShow)),
                        loadImages(cloneRange))
                      : _.currentSlide === 0 &&
                        ((cloneRange = _.$slider.find(".slick-cloned").slice(_.options.slidesToShow * -1)),
                        loadImages(cloneRange));
        }),
        (Slick.prototype.loadSlider = function () {
            var _ = this;
            _.setPosition(),
                _.$slideTrack.css({ opacity: 1 }),
                _.$slider.removeClass("slick-loading"),
                _.initUI(),
                _.options.lazyLoad === "progressive" && _.progressiveLazyLoad();
        }),
        (Slick.prototype.next = Slick.prototype.slickNext =
            function () {
                var _ = this;
                _.changeSlide({ data: { message: "next" } });
            }),
        (Slick.prototype.orientationChange = function () {
            var _ = this;
            _.checkResponsive(), _.setPosition();
        }),
        (Slick.prototype.pause = Slick.prototype.slickPause =
            function () {
                var _ = this;
                _.autoPlayClear(), (_.paused = !0);
            }),
        (Slick.prototype.play = Slick.prototype.slickPlay =
            function () {
                var _ = this;
                _.autoPlay(), (_.options.autoplay = !0), (_.paused = !1), (_.focussed = !1), (_.interrupted = !1);
            }),
        (Slick.prototype.postSlide = function (index) {
            var _ = this;
            if (
                !_.unslicked &&
                (_.$slider.trigger("afterChange", [_, index]),
                (_.animating = !1),
                _.slideCount > _.options.slidesToShow && _.setPosition(),
                (_.swipeLeft = null),
                _.options.autoplay && _.autoPlay(),
                _.options.accessibility === !0 && (_.initADA(), _.options.focusOnChange))
            ) {
                var $currentSlide = $(_.$slides.get(_.currentSlide));
                $currentSlide.attr("tabindex", 0).focus();
            }
        }),
        (Slick.prototype.prev = Slick.prototype.slickPrev =
            function () {
                var _ = this;
                _.changeSlide({ data: { message: "previous" } });
            }),
        (Slick.prototype.preventDefault = function (event) {
            event.preventDefault();
        }),
        (Slick.prototype.progressiveLazyLoad = function (tryCount) {
            tryCount = tryCount || 1;
            var _ = this,
                $imgsToLoad = $("img[data-lazy]", _.$slider),
                image,
                imageSource,
                imageSrcSet,
                imageSizes,
                imageToLoad;
            $imgsToLoad.length
                ? ((image = $imgsToLoad.first()),
                  (imageSource = image.attr("data-lazy")),
                  (imageSrcSet = image.attr("data-srcset")),
                  (imageSizes = image.attr("data-sizes") || _.$slider.attr("data-sizes")),
                  (imageToLoad = document.createElement("img")),
                  (imageToLoad.onload = function () {
                      imageSrcSet && (image.attr("srcset", imageSrcSet), imageSizes && image.attr("sizes", imageSizes)),
                          image
                              .attr("src", imageSource)
                              .removeAttr("data-lazy data-srcset data-sizes")
                              .removeClass("slick-loading"),
                          _.options.adaptiveHeight === !0 && _.setPosition(),
                          _.$slider.trigger("lazyLoaded", [_, image, imageSource]),
                          _.progressiveLazyLoad();
                  }),
                  (imageToLoad.onerror = function () {
                      tryCount < 3
                          ? setTimeout(function () {
                                _.progressiveLazyLoad(tryCount + 1);
                            }, 500)
                          : (image
                                .removeAttr("data-lazy")
                                .removeClass("slick-loading")
                                .addClass("slick-lazyload-error"),
                            _.$slider.trigger("lazyLoadError", [_, image, imageSource]),
                            _.progressiveLazyLoad());
                  }),
                  (imageToLoad.src = imageSource))
                : _.$slider.trigger("allImagesLoaded", [_]);
        }),
        (Slick.prototype.refresh = function (initializing) {
            var _ = this,
                currentSlide,
                lastVisibleIndex;
            (lastVisibleIndex = _.slideCount - _.options.slidesToShow),
                !_.options.infinite && _.currentSlide > lastVisibleIndex && (_.currentSlide = lastVisibleIndex),
                _.slideCount <= _.options.slidesToShow && (_.currentSlide = 0),
                (currentSlide = _.currentSlide),
                _.destroy(!0),
                $.extend(_, _.initials, { currentSlide: currentSlide }),
                _.init(),
                initializing || _.changeSlide({ data: { message: "index", index: currentSlide } }, !1);
        }),
        (Slick.prototype.registerBreakpoints = function () {
            var _ = this,
                breakpoint,
                currentBreakpoint,
                l,
                responsiveSettings = _.options.responsive || null;
            if ($.type(responsiveSettings) === "array" && responsiveSettings.length) {
                _.respondTo = _.options.respondTo || "window";
                for (breakpoint in responsiveSettings)
                    if (((l = _.breakpoints.length - 1), responsiveSettings.hasOwnProperty(breakpoint))) {
                        for (currentBreakpoint = responsiveSettings[breakpoint].breakpoint; l >= 0; )
                            _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint && _.breakpoints.splice(l, 1),
                                l--;
                        _.breakpoints.push(currentBreakpoint),
                            (_.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings);
                    }
                _.breakpoints.sort(function (a, b) {
                    return _.options.mobileFirst ? a - b : b - a;
                });
            }
        }),
        (Slick.prototype.reinit = function () {
            var _ = this;
            (_.$slides = _.$slideTrack.children(_.options.slide).addClass("slick-slide")),
                (_.slideCount = _.$slides.length),
                _.currentSlide >= _.slideCount &&
                    _.currentSlide !== 0 &&
                    (_.currentSlide = _.currentSlide - _.options.slidesToScroll),
                _.slideCount <= _.options.slidesToShow && (_.currentSlide = 0),
                _.registerBreakpoints(),
                _.setProps(),
                _.setupInfinite(),
                _.buildArrows(),
                _.updateArrows(),
                _.initArrowEvents(),
                _.buildDots(),
                _.updateDots(),
                _.initDotEvents(),
                _.cleanUpSlideEvents(),
                _.initSlideEvents(),
                _.checkResponsive(!1, !0),
                _.options.focusOnSelect === !0 && $(_.$slideTrack).children().on("click.slick", _.selectHandler),
                _.setSlideClasses(typeof _.currentSlide == "number" ? _.currentSlide : 0),
                _.setPosition(),
                _.focusHandler(),
                (_.paused = !_.options.autoplay),
                _.autoPlay(),
                _.$slider.trigger("reInit", [_]);
        }),
        (Slick.prototype.resize = function () {
            var _ = this;
            $(window).width() !== _.windowWidth &&
                (clearTimeout(_.windowDelay),
                (_.windowDelay = window.setTimeout(function () {
                    (_.windowWidth = $(window).width()), _.checkResponsive(), _.unslicked || _.setPosition();
                }, 50)));
        }),
        (Slick.prototype.removeSlide = Slick.prototype.slickRemove =
            function (index, removeBefore, removeAll) {
                var _ = this;
                if (
                    (typeof index == "boolean"
                        ? ((removeBefore = index), (index = removeBefore === !0 ? 0 : _.slideCount - 1))
                        : (index = removeBefore === !0 ? --index : index),
                    _.slideCount < 1 || index < 0 || index > _.slideCount - 1)
                )
                    return !1;
                _.unload(),
                    removeAll === !0
                        ? _.$slideTrack.children().remove()
                        : _.$slideTrack.children(this.options.slide).eq(index).remove(),
                    (_.$slides = _.$slideTrack.children(this.options.slide)),
                    _.$slideTrack.children(this.options.slide).detach(),
                    _.$slideTrack.append(_.$slides),
                    (_.$slidesCache = _.$slides),
                    _.reinit();
            }),
        (Slick.prototype.setCSS = function (position) {
            var _ = this,
                positionProps = {},
                x,
                y;
            _.options.rtl === !0 && (position = -position),
                (x = _.positionProp == "left" ? Math.ceil(position) + "px" : "0px"),
                (y = _.positionProp == "top" ? Math.ceil(position) + "px" : "0px"),
                (positionProps[_.positionProp] = position),
                _.transformsEnabled === !1
                    ? _.$slideTrack.css(positionProps)
                    : ((positionProps = {}),
                      _.cssTransitions === !1
                          ? ((positionProps[_.animType] = "translate(" + x + ", " + y + ")"),
                            _.$slideTrack.css(positionProps))
                          : ((positionProps[_.animType] = "translate3d(" + x + ", " + y + ", 0px)"),
                            _.$slideTrack.css(positionProps)));
        }),
        (Slick.prototype.setDimensions = function () {
            var _ = this;
            _.options.vertical === !1
                ? _.options.centerMode === !0 && _.$list.css({ padding: "0px " + _.options.centerPadding })
                : (_.$list.height(_.$slides.first().outerHeight(!0) * _.options.slidesToShow),
                  _.options.centerMode === !0 && _.$list.css({ padding: _.options.centerPadding + " 0px" })),
                (_.listWidth = _.$list.width()),
                (_.listHeight = _.$list.height()),
                _.options.vertical === !1 && _.options.variableWidth === !1
                    ? ((_.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow)),
                      _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children(".slick-slide").length)))
                    : _.options.variableWidth === !0
                      ? _.$slideTrack.width(5e3 * _.slideCount)
                      : ((_.slideWidth = Math.ceil(_.listWidth)),
                        _.$slideTrack.height(
                            Math.ceil(_.$slides.first().outerHeight(!0) * _.$slideTrack.children(".slick-slide").length)
                        ));
            var offset = _.$slides.first().outerWidth(!0) - _.$slides.first().width();
            _.options.variableWidth === !1 && _.$slideTrack.children(".slick-slide").width(_.slideWidth - offset);
        }),
        (Slick.prototype.setFade = function () {
            var _ = this,
                targetLeft;
            _.$slides.each(function (index, element) {
                (targetLeft = _.slideWidth * index * -1),
                    _.options.rtl === !0
                        ? $(element).css({
                              position: "relative",
                              right: targetLeft,
                              top: 0,
                              zIndex: _.options.zIndex - 2,
                              opacity: 0,
                          })
                        : $(element).css({
                              position: "relative",
                              left: targetLeft,
                              top: 0,
                              zIndex: _.options.zIndex - 2,
                              opacity: 0,
                          });
            }),
                _.$slides.eq(_.currentSlide).css({ zIndex: _.options.zIndex - 1, opacity: 1 });
        }),
        (Slick.prototype.setHeight = function () {
            var _ = this;
            if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === !0 && _.options.vertical === !1) {
                var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(!0);
                _.$list.css("height", targetHeight);
            }
        }),
        (Slick.prototype.setOption = Slick.prototype.slickSetOption =
            function () {
                var _ = this,
                    l,
                    item,
                    option,
                    value,
                    refresh = !1,
                    type;
                if (
                    ($.type(arguments[0]) === "object"
                        ? ((option = arguments[0]), (refresh = arguments[1]), (type = "multiple"))
                        : $.type(arguments[0]) === "string" &&
                          ((option = arguments[0]),
                          (value = arguments[1]),
                          (refresh = arguments[2]),
                          arguments[0] === "responsive" && $.type(arguments[1]) === "array"
                              ? (type = "responsive")
                              : typeof arguments[1] != "undefined" && (type = "single")),
                    type === "single")
                )
                    _.options[option] = value;
                else if (type === "multiple")
                    $.each(option, function (opt, val) {
                        _.options[opt] = val;
                    });
                else if (type === "responsive")
                    for (item in value)
                        if ($.type(_.options.responsive) !== "array") _.options.responsive = [value[item]];
                        else {
                            for (l = _.options.responsive.length - 1; l >= 0; )
                                _.options.responsive[l].breakpoint === value[item].breakpoint &&
                                    _.options.responsive.splice(l, 1),
                                    l--;
                            _.options.responsive.push(value[item]);
                        }
                refresh && (_.unload(), _.reinit());
            }),
        (Slick.prototype.setPosition = function () {
            var _ = this;
            _.setDimensions(),
                _.setHeight(),
                _.options.fade === !1 ? _.setCSS(_.getLeft(_.currentSlide)) : _.setFade(),
                _.$slider.trigger("setPosition", [_]);
        }),
        (Slick.prototype.setProps = function () {
            var _ = this,
                bodyStyle = document.body.style;
            (_.positionProp = _.options.vertical === !0 ? "top" : "left"),
                _.positionProp === "top"
                    ? _.$slider.addClass("slick-vertical")
                    : _.$slider.removeClass("slick-vertical"),
                (bodyStyle.WebkitTransition !== void 0 ||
                    bodyStyle.MozTransition !== void 0 ||
                    bodyStyle.msTransition !== void 0) &&
                    _.options.useCSS === !0 &&
                    (_.cssTransitions = !0),
                _.options.fade &&
                    (typeof _.options.zIndex == "number"
                        ? _.options.zIndex < 3 && (_.options.zIndex = 3)
                        : (_.options.zIndex = _.defaults.zIndex)),
                bodyStyle.OTransform !== void 0 &&
                    ((_.animType = "OTransform"),
                    (_.transformType = "-o-transform"),
                    (_.transitionType = "OTransition"),
                    bodyStyle.perspectiveProperty === void 0 &&
                        bodyStyle.webkitPerspective === void 0 &&
                        (_.animType = !1)),
                bodyStyle.MozTransform !== void 0 &&
                    ((_.animType = "MozTransform"),
                    (_.transformType = "-moz-transform"),
                    (_.transitionType = "MozTransition"),
                    bodyStyle.perspectiveProperty === void 0 &&
                        bodyStyle.MozPerspective === void 0 &&
                        (_.animType = !1)),
                bodyStyle.webkitTransform !== void 0 &&
                    ((_.animType = "webkitTransform"),
                    (_.transformType = "-webkit-transform"),
                    (_.transitionType = "webkitTransition"),
                    bodyStyle.perspectiveProperty === void 0 &&
                        bodyStyle.webkitPerspective === void 0 &&
                        (_.animType = !1)),
                bodyStyle.msTransform !== void 0 &&
                    ((_.animType = "msTransform"),
                    (_.transformType = "-ms-transform"),
                    (_.transitionType = "msTransition"),
                    bodyStyle.msTransform === void 0 && (_.animType = !1)),
                bodyStyle.transform !== void 0 &&
                    _.animType !== !1 &&
                    ((_.animType = "transform"), (_.transformType = "transform"), (_.transitionType = "transition")),
                (_.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== !1);
        }),
        (Slick.prototype.setSlideClasses = function (index) {
            var _ = this,
                centerOffset,
                allSlides,
                indexOffset,
                remainder;
            if (
                ((allSlides = _.$slider
                    .find(".slick-slide")
                    .removeClass("slick-active slick-center slick-current")
                    .attr("aria-hidden", "true")),
                _.$slides.eq(index).addClass("slick-current"),
                _.options.centerMode === !0)
            ) {
                var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
                (centerOffset = Math.floor(_.options.slidesToShow / 2)),
                    _.options.infinite === !0 &&
                        (index >= centerOffset && index <= _.slideCount - 1 - centerOffset
                            ? _.$slides
                                  .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")
                            : ((indexOffset = _.options.slidesToShow + index),
                              allSlides
                                  .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")),
                        index === 0
                            ? allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass("slick-center")
                            : index === _.slideCount - 1 &&
                              allSlides.eq(_.options.slidesToShow).addClass("slick-center")),
                    _.$slides.eq(index).addClass("slick-center");
            } else
                index >= 0 && index <= _.slideCount - _.options.slidesToShow
                    ? _.$slides
                          .slice(index, index + _.options.slidesToShow)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")
                    : allSlides.length <= _.options.slidesToShow
                      ? allSlides.addClass("slick-active").attr("aria-hidden", "false")
                      : ((remainder = _.slideCount % _.options.slidesToShow),
                        (indexOffset = _.options.infinite === !0 ? _.options.slidesToShow + index : index),
                        _.options.slidesToShow == _.options.slidesToScroll &&
                        _.slideCount - index < _.options.slidesToShow
                            ? allSlides
                                  .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false")
                            : allSlides
                                  .slice(indexOffset, indexOffset + _.options.slidesToShow)
                                  .addClass("slick-active")
                                  .attr("aria-hidden", "false"));
            (_.options.lazyLoad === "ondemand" || _.options.lazyLoad === "anticipated") && _.lazyLoad();
        }),
        (Slick.prototype.setupInfinite = function () {
            var _ = this,
                i,
                slideIndex,
                infiniteCount;
            if (
                (_.options.fade === !0 && (_.options.centerMode = !1),
                _.options.infinite === !0 &&
                    _.options.fade === !1 &&
                    ((slideIndex = null), _.slideCount > _.options.slidesToShow))
            ) {
                for (
                    _.options.centerMode === !0
                        ? (infiniteCount = _.options.slidesToShow + 1)
                        : (infiniteCount = _.options.slidesToShow),
                        i = _.slideCount;
                    i > _.slideCount - infiniteCount;
                    i -= 1
                )
                    (slideIndex = i - 1),
                        $(_.$slides[slideIndex])
                            .clone(!0)
                            .attr("id", "")
                            .attr("data-slick-index", slideIndex - _.slideCount)
                            .prependTo(_.$slideTrack)
                            .addClass("slick-cloned");
                for (i = 0; i < infiniteCount + _.slideCount; i += 1)
                    (slideIndex = i),
                        $(_.$slides[slideIndex])
                            .clone(!0)
                            .attr("id", "")
                            .attr("data-slick-index", slideIndex + _.slideCount)
                            .appendTo(_.$slideTrack)
                            .addClass("slick-cloned");
                _.$slideTrack
                    .find(".slick-cloned")
                    .find("[id]")
                    .each(function () {
                        $(this).attr("id", "");
                    });
            }
        }),
        (Slick.prototype.interrupt = function (toggle) {
            var _ = this;
            toggle || _.autoPlay(), (_.interrupted = toggle);
        }),
        (Slick.prototype.selectHandler = function (event) {
            var _ = this,
                targetElement = $(event.target).is(".slick-slide")
                    ? $(event.target)
                    : $(event.target).parents(".slick-slide"),
                index = parseInt(targetElement.attr("data-slick-index"));
            if ((index || (index = 0), _.slideCount <= _.options.slidesToShow)) {
                _.slideHandler(index, !1, !0);
                return;
            }
            _.slideHandler(index);
        }),
        (Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
            var targetSlide,
                animSlide,
                oldSlide,
                slideLeft,
                targetLeft = null,
                _ = this,
                navTarget;
            if (
                ((sync = sync || !1),
                !(_.animating === !0 && _.options.waitForAnimate === !0) &&
                    !(_.options.fade === !0 && _.currentSlide === index))
            ) {
                if (
                    (sync === !1 && _.asNavFor(index),
                    (targetSlide = index),
                    (targetLeft = _.getLeft(targetSlide)),
                    (slideLeft = _.getLeft(_.currentSlide)),
                    (_.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft),
                    _.options.infinite === !1 &&
                        _.options.centerMode === !1 &&
                        (index < 0 || index > _.getDotCount() * _.options.slidesToScroll))
                ) {
                    _.options.fade === !1 &&
                        ((targetSlide = _.currentSlide),
                        dontAnimate !== !0 && _.slideCount > _.options.slidesToShow
                            ? _.animateSlide(slideLeft, function () {
                                  _.postSlide(targetSlide);
                              })
                            : _.postSlide(targetSlide));
                    return;
                } else if (
                    _.options.infinite === !1 &&
                    _.options.centerMode === !0 &&
                    (index < 0 || index > _.slideCount - _.options.slidesToScroll)
                ) {
                    _.options.fade === !1 &&
                        ((targetSlide = _.currentSlide),
                        dontAnimate !== !0 && _.slideCount > _.options.slidesToShow
                            ? _.animateSlide(slideLeft, function () {
                                  _.postSlide(targetSlide);
                              })
                            : _.postSlide(targetSlide));
                    return;
                }
                if (
                    (_.options.autoplay && clearInterval(_.autoPlayTimer),
                    targetSlide < 0
                        ? _.slideCount % _.options.slidesToScroll !== 0
                            ? (animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll))
                            : (animSlide = _.slideCount + targetSlide)
                        : targetSlide >= _.slideCount
                          ? _.slideCount % _.options.slidesToScroll !== 0
                              ? (animSlide = 0)
                              : (animSlide = targetSlide - _.slideCount)
                          : (animSlide = targetSlide),
                    (_.animating = !0),
                    _.$slider.trigger("beforeChange", [_, _.currentSlide, animSlide]),
                    (oldSlide = _.currentSlide),
                    (_.currentSlide = animSlide),
                    _.setSlideClasses(_.currentSlide),
                    _.options.asNavFor &&
                        ((navTarget = _.getNavTarget()),
                        (navTarget = navTarget.slick("getSlick")),
                        navTarget.slideCount <= navTarget.options.slidesToShow &&
                            navTarget.setSlideClasses(_.currentSlide)),
                    _.updateDots(),
                    _.updateArrows(),
                    _.options.fade === !0)
                ) {
                    dontAnimate !== !0
                        ? (_.fadeSlideOut(oldSlide),
                          _.fadeSlide(animSlide, function () {
                              _.postSlide(animSlide);
                          }))
                        : _.postSlide(animSlide),
                        _.animateHeight();
                    return;
                }
                dontAnimate !== !0 && _.slideCount > _.options.slidesToShow
                    ? _.animateSlide(targetLeft, function () {
                          _.postSlide(animSlide);
                      })
                    : _.postSlide(animSlide);
            }
        }),
        (Slick.prototype.startLoad = function () {
            var _ = this;
            _.options.arrows === !0 &&
                _.slideCount > _.options.slidesToShow &&
                (_.$prevArrow.hide(), _.$nextArrow.hide()),
                _.options.dots === !0 && _.slideCount > _.options.slidesToShow && _.$dots.hide(),
                _.$slider.addClass("slick-loading");
        }),
        (Slick.prototype.swipeDirection = function () {
            var xDist,
                yDist,
                r,
                swipeAngle,
                _ = this;
            return (
                (xDist = _.touchObject.startX - _.touchObject.curX),
                (yDist = _.touchObject.startY - _.touchObject.curY),
                (r = Math.atan2(yDist, xDist)),
                (swipeAngle = Math.round((r * 180) / Math.PI)),
                swipeAngle < 0 && (swipeAngle = 360 - Math.abs(swipeAngle)),
                (swipeAngle <= 45 && swipeAngle >= 0) || (swipeAngle <= 360 && swipeAngle >= 315)
                    ? _.options.rtl === !1
                        ? "left"
                        : "right"
                    : swipeAngle >= 135 && swipeAngle <= 225
                      ? _.options.rtl === !1
                          ? "right"
                          : "left"
                      : _.options.verticalSwiping === !0
                        ? swipeAngle >= 35 && swipeAngle <= 135
                            ? "down"
                            : "up"
                        : "vertical"
            );
        }),
        (Slick.prototype.swipeEnd = function (event) {
            var _ = this,
                slideCount,
                direction;
            if (((_.dragging = !1), (_.swiping = !1), _.scrolling)) return (_.scrolling = !1), !1;
            if (
                ((_.interrupted = !1),
                (_.shouldClick = !(_.touchObject.swipeLength > 10)),
                _.touchObject.curX === void 0)
            )
                return !1;
            if (
                (_.touchObject.edgeHit === !0 && _.$slider.trigger("edge", [_, _.swipeDirection()]),
                _.touchObject.swipeLength >= _.touchObject.minSwipe)
            ) {
                switch (((direction = _.swipeDirection()), direction)) {
                    case "left":
                    case "down":
                        (slideCount = _.options.swipeToSlide
                            ? _.checkNavigable(_.currentSlide + _.getSlideCount())
                            : _.currentSlide + _.getSlideCount()),
                            (_.currentDirection = 0);
                        break;
                    case "right":
                    case "up":
                        (slideCount = _.options.swipeToSlide
                            ? _.checkNavigable(_.currentSlide - _.getSlideCount())
                            : _.currentSlide - _.getSlideCount()),
                            (_.currentDirection = 1);
                        break;
                    default:
                }
                direction != "vertical" &&
                    (_.slideHandler(slideCount), (_.touchObject = {}), _.$slider.trigger("swipe", [_, direction]));
            } else
                _.touchObject.startX !== _.touchObject.curX && (_.slideHandler(_.currentSlide), (_.touchObject = {}));
        }),
        (Slick.prototype.swipeHandler = function (event) {
            var _ = this;
            if (
                !(_.options.swipe === !1 || ("ontouchend" in document && _.options.swipe === !1)) &&
                !(_.options.draggable === !1 && event.type.indexOf("mouse") !== -1)
            )
                switch (
                    ((_.touchObject.fingerCount =
                        event.originalEvent && event.originalEvent.touches !== void 0
                            ? event.originalEvent.touches.length
                            : 1),
                    (_.touchObject.minSwipe = _.listWidth / _.options.touchThreshold),
                    _.options.verticalSwiping === !0 &&
                        (_.touchObject.minSwipe = _.listHeight / _.options.touchThreshold),
                    event.data.action)
                ) {
                    case "start":
                        _.swipeStart(event);
                        break;
                    case "move":
                        _.swipeMove(event);
                        break;
                    case "end":
                        _.swipeEnd(event);
                        break;
                }
        }),
        (Slick.prototype.swipeMove = function (event) {
            var _ = this,
                edgeWasHit = !1,
                curLeft,
                swipeDirection,
                swipeLength,
                positionOffset,
                touches,
                verticalSwipeLength;
            if (
                ((touches = event.originalEvent !== void 0 ? event.originalEvent.touches : null),
                !_.dragging || _.scrolling || (touches && touches.length !== 1))
            )
                return !1;
            if (
                ((curLeft = _.getLeft(_.currentSlide)),
                (_.touchObject.curX = touches !== void 0 ? touches[0].pageX : event.clientX),
                (_.touchObject.curY = touches !== void 0 ? touches[0].pageY : event.clientY),
                (_.touchObject.swipeLength = Math.round(
                    Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2))
                )),
                (verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)))),
                !_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4)
            )
                return (_.scrolling = !0), !1;
            if (
                (_.options.verticalSwiping === !0 && (_.touchObject.swipeLength = verticalSwipeLength),
                (swipeDirection = _.swipeDirection()),
                event.originalEvent !== void 0 &&
                    _.touchObject.swipeLength > 4 &&
                    ((_.swiping = !0), event.preventDefault()),
                (positionOffset =
                    (_.options.rtl === !1 ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1)),
                _.options.verticalSwiping === !0 &&
                    (positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1),
                (swipeLength = _.touchObject.swipeLength),
                (_.touchObject.edgeHit = !1),
                _.options.infinite === !1 &&
                    ((_.currentSlide === 0 && swipeDirection === "right") ||
                        (_.currentSlide >= _.getDotCount() && swipeDirection === "left")) &&
                    ((swipeLength = _.touchObject.swipeLength * _.options.edgeFriction), (_.touchObject.edgeHit = !0)),
                _.options.vertical === !1
                    ? (_.swipeLeft = curLeft + swipeLength * positionOffset)
                    : (_.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset),
                _.options.verticalSwiping === !0 && (_.swipeLeft = curLeft + swipeLength * positionOffset),
                _.options.fade === !0 || _.options.touchMove === !1)
            )
                return !1;
            if (_.animating === !0) return (_.swipeLeft = null), !1;
            _.setCSS(_.swipeLeft);
        }),
        (Slick.prototype.swipeStart = function (event) {
            var _ = this,
                touches;
            if (((_.interrupted = !0), _.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow))
                return (_.touchObject = {}), !1;
            event.originalEvent !== void 0 &&
                event.originalEvent.touches !== void 0 &&
                (touches = event.originalEvent.touches[0]),
                (_.touchObject.startX = _.touchObject.curX = touches !== void 0 ? touches.pageX : event.clientX),
                (_.touchObject.startY = _.touchObject.curY = touches !== void 0 ? touches.pageY : event.clientY),
                (_.dragging = !0);
        }),
        (Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter =
            function () {
                var _ = this;
                _.$slidesCache !== null &&
                    (_.unload(),
                    _.$slideTrack.children(this.options.slide).detach(),
                    _.$slidesCache.appendTo(_.$slideTrack),
                    _.reinit());
            }),
        (Slick.prototype.unload = function () {
            var _ = this;
            $(".slick-cloned", _.$slider).remove(),
                _.$dots && _.$dots.remove(),
                _.$prevArrow && _.htmlExpr.test(_.options.prevArrow) && _.$prevArrow.remove(),
                _.$nextArrow && _.htmlExpr.test(_.options.nextArrow) && _.$nextArrow.remove(),
                _.$slides
                    .removeClass("slick-slide slick-active slick-visible slick-current")
                    .attr("aria-hidden", "true")
                    .css("width", "");
        }),
        (Slick.prototype.unslick = function (fromBreakpoint) {
            var _ = this;
            _.$slider.trigger("unslick", [_, fromBreakpoint]), _.destroy();
        }),
        (Slick.prototype.updateArrows = function () {
            var _ = this,
                centerOffset;
            (centerOffset = Math.floor(_.options.slidesToShow / 2)),
                _.options.arrows === !0 &&
                    _.slideCount > _.options.slidesToShow &&
                    !_.options.infinite &&
                    (_.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                    _.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                    _.currentSlide === 0
                        ? (_.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                          _.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                        : ((_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === !1) ||
                              (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === !0)) &&
                          (_.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                          _.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
        }),
        (Slick.prototype.updateDots = function () {
            var _ = this;
            _.$dots !== null &&
                (_.$dots.find("li").removeClass("slick-active").end(),
                _.$dots
                    .find("li")
                    .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                    .addClass("slick-active"));
        }),
        (Slick.prototype.visibility = function () {
            var _ = this;
            _.options.autoplay && (document[_.hidden] ? (_.interrupted = !0) : (_.interrupted = !1));
        }),
        ($.fn.slick = function () {
            var _ = this,
                opt = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                l = _.length,
                i,
                ret;
            for (i = 0; i < l; i++)
                if (
                    (typeof opt == "object" || typeof opt == "undefined"
                        ? (_[i].slick = new Slick(_[i], opt))
                        : (ret = _[i].slick[opt].apply(_[i].slick, args)),
                    typeof ret != "undefined")
                )
                    return ret;
            return _;
        });
});
//# sourceMappingURL=/cdn/shop/t/4/assets/slick.js.map?v=18270799639888039791712155703
